import { ApiEndpoints, type ConsentName } from '@/types'
import { useHttpWithValidate } from '@wiosna-dev/wiosna-ui'
import { consentsResponseSchema } from '@/schemas/consents'
import endpointServiceParams from '@/services/httpTypescript/endpointServiceParams'

export default {
  getConsents(consentName: ConsentName) {
    return useHttpWithValidate({
      endpoint: ApiEndpoints.consent,
      endpointServiceParams,
      routeParams: {
        consentName
      },
      schema: consentsResponseSchema,
      options: { immediate: false }
    })
  }
}
